import React from 'react'

export type HeroHeaderProps = {
  html: string
  image: {
    url: string
    alt: string
  }
  video?: {
    url: string
  }
  videoPoster?: {
    url: string
    alt: string
  }
  lang?: string
  onRenderImage?: () => JSX.Element
  onRenderButton?: () => JSX.Element
}

const HeroHeader: React.FC<HeroHeaderProps> = ({ html, onRenderImage, onRenderButton }) => {
  return (
    <div className='container new-hero-header d-lg-flex mb-5 mb-lg-0'>
      <div className='new-hero-header__image my-2 col-lg-6 px-0'>{onRenderImage && onRenderImage()}</div>
      <div className='col-lg-6 offset-lg-1 pt-lg-4 px-0'>
        <div className='article mb-md-3' dangerouslySetInnerHTML={{ __html: html }} />
        {onRenderButton && onRenderButton()}
      </div>
    </div>
  )
}

export default HeroHeader
